/* Cabeçalho das páginas de venda: mega menu (rato, toque, teclado) e gaveta do telemóvel.
   O carrinho abre a gaveta do tema carregando no botão do cabeçalho antigo (escondido). */
(function () {
  document.querySelectorAll('[data-pv]').forEach(function (raiz) {
    if (raiz.dataset.pvPronto) return;
    raiz.dataset.pvPronto = '1';
    var site = raiz.querySelector('[data-pv-site]');
    var botoes = Array.prototype.slice.call(raiz.querySelectorAll('.pv-navlink'));
    var fecho;
    var rato = window.matchMedia('(hover: hover)');

    function abrir(btn) {
      clearTimeout(fecho);
      botoes.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.classList.toggle('is-open', on);
      });
    }
    function fecharTudo() { abrir(null); }

    botoes.forEach(function (b) {
      b.parentElement.addEventListener('mouseenter', function () { if (rato.matches) abrir(b); });
      b.addEventListener('click', function () { b.getAttribute('aria-expanded') === 'true' ? fecharTudo() : abrir(b); });
      b.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); abrir(b); var a = document.getElementById(b.getAttribute('aria-controls')).querySelector('a'); if (a) a.focus(); } });
    });
    if (site) {
      site.addEventListener('mouseleave', function () { if (rato.matches) fecho = setTimeout(fecharTudo, 180); });
      site.addEventListener('mouseenter', function () { clearTimeout(fecho); });
      site.addEventListener('focusout', function (e) { if (!site.contains(e.relatedTarget)) fecharTudo(); });
    }
    document.addEventListener('click', function (e) { if (site && !site.contains(e.target)) fecharTudo(); });

    /* carrinho → gaveta do tema */
    var cart = raiz.querySelector('[data-pv-carrinho]');
    if (cart) cart.addEventListener('click', function (e) {
      var original = document.querySelector('.site-header .js-drawer-open-right-link');
      if (original) { e.preventDefault(); original.click(); }
    });

    /* gaveta do telemóvel */
    var gaveta = raiz.querySelector('[data-pv-gaveta]');
    var l1 = raiz.querySelector('[data-pv-l1]');
    var burger = raiz.querySelector('[data-pv-abrir]');
    function fecharGaveta() {
      if (!gaveta) return;
      gaveta.classList.remove('is-open'); gaveta.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pv-gaveta-aberta');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      l1.classList.remove('is-out');
      raiz.querySelectorAll('[data-pv-l2]').forEach(function (p) { p.classList.remove('is-in'); });
    }
    if (burger && gaveta) burger.addEventListener('click', function () {
      gaveta.classList.add('is-open'); gaveta.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pv-gaveta-aberta');
      burger.setAttribute('aria-expanded', 'true');
      var f = gaveta.querySelector('[data-pv-fechar]'); if (f) f.focus({ preventScroll: true });
    });
    raiz.querySelectorAll('[data-pv-fechar]').forEach(function (b) { b.addEventListener('click', fecharGaveta); });
    raiz.querySelectorAll('[data-pv-nivel]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = raiz.querySelector('[data-pv-l2="' + b.getAttribute('data-pv-nivel') + '"]');
        if (!p) return;
        p.scrollTop = 0; p.classList.add('is-in'); l1.classList.add('is-out');
        var v = p.querySelector('[data-pv-voltar]'); if (v) v.focus({ preventScroll: true });
        /* o foco durante a animação deslocava a gaveta (overflow: hidden) para o lado */
        gaveta.scrollLeft = 0; gaveta.scrollTop = 0;
      });
    });
    raiz.querySelectorAll('[data-pv-voltar]').forEach(function (b) {
      b.addEventListener('click', function () { b.closest('[data-pv-l2]').classList.remove('is-in'); l1.classList.remove('is-out'); gaveta.scrollLeft = 0; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { fecharTudo(); fecharGaveta(); } });
  });
})();
